import { useQuery } from '@tanstack/react-query';

import { fetchAgentHubUserById } from '~/services/AgentHub/AgentService';

import type { Agent } from '~/types/services/agentHub';

import { agentHubUserDetailQueryKeys } from './useAgentHubUserRowsDetailQueries';

interface UseGetAgentHubUserOptions {
  enabled?: boolean;
}

const FIVE_MINUTES = 5 * 60 * 1000;

export function useGetAgentHubUser(id: string, brand: string, options: UseGetAgentHubUserOptions = {}) {
  const { enabled = true } = options;

  return useQuery<Agent>({
    queryKey: agentHubUserDetailQueryKeys.detail(id, brand),
    queryFn: async () => {
      return await fetchAgentHubUserById(id);
    },
    enabled: enabled && !!id,
    staleTime: FIVE_MINUTES,
  });
}
